export default [
  {
    path: '/obs-department-question',
    name: 'obs-department-question',
    component: resolve => require(['views/obs-department-question'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/obs-department-detail/:id/:isEdit',
    name: 'obs-department-detail',
    props: true,
    component: resolve => require(['views/obs-department-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '产科问答/产科问答详情' }
  }
]
